import type { SortKey } from "@/hooks/useContentExplorer";

interface Props {
  sort: SortKey;
  onChange: (s: SortKey) => void;
  total: number;
  onOpenFilter?: () => void;
}

export default function SortBar({ sort, onChange, total, onOpenFilter }: Props) {
  const options: { key: SortKey; label: string; icon: string }[] = [
    { key: "new", label: "最新更新", icon: "ri-time-line" },
    { key: "hot", label: "热门排序", icon: "ri-fire-line" },
  ];

  return (
    <div className="flex items-center justify-between gap-3 mb-5 flex-wrap">
      <p className="text-sm text-foreground-600">
        共 <span className="font-semibold text-foreground-900">{total}</span> 部资源
      </p>
      <div className="flex items-center gap-2">
        {onOpenFilter && (
          <button
            type="button"
            onClick={onOpenFilter}
            className="lg:hidden flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-xs text-foreground-700 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-filter-3-line" />
            筛选
          </button>
        )}
        <div className="flex items-center rounded-full bg-background-100 p-1">
          {options.map((opt) => (
            <button
              key={opt.key}
              type="button"
              onClick={() => onChange(opt.key)}
              className={`flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                sort === opt.key
                  ? "bg-background-50 text-primary-700 font-medium shadow-sm"
                  : "text-foreground-500 hover:text-foreground-800"
              }`}
            >
              <i className={opt.icon} />
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}